<template>
    <div>
      <BannerList v-for="(layoutItem, index) in columnLayoutList" :key="index" :bannerList="layoutItem.bannerlist"
      :columnType="layoutItem.columnType" />
    </div>
  </template>

<script setup lang="ts">
import { onBeforeMount, ref, Ref } from 'vue';
import { useConfigStore } from '@/store';
import BannerList from '@/components/common/banner-list.vue';
import { ColumnLayout, ColumnType } from '@/types/banner-layout';
const { getFilteredLayout } = useConfigStore();

// banner 列表
const columnLayoutList: Ref<ColumnLayout[] | null> = ref(null);

onBeforeMount(async () => {
  const bannerConfig = await getFilteredLayout([ColumnType.d]);
  if (bannerConfig) {
    columnLayoutList.value = bannerConfig;
  }
});

</script>
  <style lang="less" scoped>
  @import (reference) '~@/less/main.less';

  </style>
